import { useSpring } from '@react-spring/web';
import { ReactElement, useLayoutEffect, useState } from 'react';

import { ButtonWrapper, DivWrapper } from './styles';
import type { NoticeProps } from './types';

const Notice = ({
	children,
	isSuccess,
	onClick,
	describedBy,
	className,
	dismissButtonAriaLabel = 'Dismiss',
}: NoticeProps): ReactElement => {
	const [isReady, setIsReady] = useState(false);

	const springProps = useSpring({
		to: {
			height: isReady ? 'auto' : 0,
			opacity: isReady ? 1 : 0,
			transform: isReady ? 'scale(1)' : 'scale(0.85)',
		},
		config: { mass: 5, tension: 350, friction: 40 },
	});

	useLayoutEffect(() => {
		setIsReady(true);
	}, []);

	const props = {
		className,
		$isSuccess: isSuccess,
		style: springProps,
	};

	const staticAriaProps = {
		role: 'alert',
		'aria-live': 'polite',
	} as const;
	const ariaProps = {
		...staticAriaProps,
		'aria-invalid': !isSuccess,
		'aria-describedby': describedBy,
	};

	return (
		<DivWrapper {...props}>
			{onClick ? <ButtonWrapper onClick={onClick} aria-label={dismissButtonAriaLabel} /> : null}
			<span {...ariaProps}>{children}</span>
		</DivWrapper>
	);
};

export default Notice;
